<template>
  <div class="junhe-index">
    <img class="logo-img" src="/static/images/junhe/logo.png" alt="logo">
    <div v-if="replyCode == '300101' || replyCode == '300102'" class="content-container">
      <img class="qr-img" src="/static/images/junhe/qr.png" alt="qr">
      <div class="title-text">感谢您选择尼德克镜片</div>
      <div class="subtitle-text">用专业品质，为你定格每一刻清晰</div>
      <div class="button" @click="toJoin">
        <span class="button-text">领取积分</span>
        <img class="right-img" src="/static/images/junhe/right.png" alt="right">
      </div>
    </div>
    <div class="bottom-links">
      <span class="link-text" @click="goToRule">规则说明</span>
    </div>
  </div>
</template>

<script>
import { getAntiData,getWechatAuth } from '../../api/api'
export default {
  name: 'JunHeIndex',
  data() {
    return {
      appId: process.env.ENV_NUM === '1' ? 'wx2fd80b8155ff35c2' : 'wxbc22565b3e7a59fd',
      eno: process.env.ENV_NUM === '1' ? '138957521686' : '138844770528',
      deptId: process.env.ENV_NUM === '1' ? '109' : '1031',
      antiCode: '',
      replyCode: '',
    }
  },
  mounted() {
    this.queryAntiCode(this.$route.query.c)
  },
  methods: {
    toJoin() {
      // 每次点击都获取最新的微信授权
      const redirectUrl = window.location.origin + '/junhe/activity';
      const params = new URLSearchParams();
      params.append('eno', this.eno);
      params.append('c', this.antiCode);
      params.append('deptId', this.deptId);

      const fullRedirectUrl = redirectUrl + '?' + params.toString();

      getWechatAuth(encodeURIComponent(fullRedirectUrl), this.appId, 1).then(res => {
        const data = res.data;
        window.location.href = data;
      }).catch(err => {
        alert("获取微信授权失败" + err);
      });
    },
    async queryAntiCode(code) {
      try {

        if (code && code.length >= 16) {
          this.antiCode = code.substring(0, 16)
        } else if (code) {
          this.antiCode = code
        }
        const res = await getAntiData(this.antiCode, this.eno)

        const data = res.data
        if (data == null || data.code == "500") {
          alert("防伪查询失败")
          return
        }
        var replyCode = data.data.replyCode
        if (replyCode === "300101" || replyCode === "300102") {
        }
        this.replyCode = replyCode
      } catch (error) {
        alert("防伪查询失败")
      }
    },
    goToRecord() {
      this.$router.push('/junhe/record')
    },
    goToRule() {
      const params = new URLSearchParams()
      params.append('deptId', this.deptId)
      window.location.href = '/junhe/rule?' + params.toString()
    }
  }
}
</script>

<style scoped>
.junhe-index {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  background: url("/static/images/junhe/bg.png") no-repeat center top;
  background-size: cover;
}

.logo-img {
  position: absolute;
  top: 3vh;
  right: 8vw;
  width: 20vw;
  height: auto;
}

.content-container {
  position: absolute;
  top: 44vh;
  left: 0;
  width: 100vw;
  height: 40vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.qr-img {
  width: 20vw;
  height: auto;
}

.title-text {
  color: white;
  font-size: 6vw;
  font-weight: bold;
  margin-top: 3vh;
}

.subtitle-text {
  color: white;
  font-size: 4vw;
  margin-top: 1vh;
}

.button {
  width: 70vw;
  height: 45px;
  background-color: rgb(0, 16, 214);
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 7vh;
  position: relative;
}

.button-text {
  color: white;
  font-size: 5vw;
  font-weight: bold;
}

.right-img {
  position: absolute;
  right: 15px;
  width: 20px;
  height: auto;
}

.bottom-links {
  position: fixed;
  bottom: 4vh;
  left: 0;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.link-text {
  color: white;
  font-size: 4vw;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/JunHe/Index.vue